export const subMenu = () => {
    const $menuItems = $('.js-nav-trigger')
    const $allMenuChildren = $('.nav-child')
    const $navigationFader = $('.navigation__fader')

    function closeAllMenus () {
        $allMenuChildren.removeClass('open').attr('hidden', true)
        $menuItems.attr('aria-expanded', 'false')
        $menuItems.find('.mobile-sub-navi-trigger').removeClass('open')
    }

    $navigationFader.addClass('invisible')

    $menuItems.on('click', function clickMenu (e) {
        e.stopPropagation()

        const $button = $(this)
        const $nextMenuChild = $(this).next($allMenuChildren)
        const $caretButton = $button.find('.mobile-sub-navi-trigger')
        const isOpen = $nextMenuChild.hasClass('open')

        closeAllMenus()

        if (!isOpen) {
            $nextMenuChild.addClass('open').removeAttr('hidden')
            $button.find('button').attr('aria-expanded', 'true')
            $caretButton.addClass('open')
        }
    })

    $('.nav').on('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
            closeAllMenus()
            $(this).focus()
        }
    })

    $('html').on('click', () => {
        closeAllMenus()
    })

    $(window).on('popstate', () => {
        closeAllMenus()
    })

    /**
     * Close navigation after any navigation link is clicked
     * Prevent leaving opened menu behind if going back in history
     */
    $('.nav .menu-item a').on('click', () => {
        $('#close-navigation-trigger').trigger('click')
        closeAllMenus()
    })
}
